import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material";
import classNames from "classnames";
import * as React from "react";

import { RobotoIconButton } from "@/shared/components/RobotoIconButton";
import { RobotoTooltip } from "@/shared/components/RobotoTooltip";
import { Tab, Tabs, TabsList, TabsPanel } from "@/shared/foundation/primitives";

import { SidebarTab, useWorkspaceSidebar } from "../sidebarContext";

import { EventList } from "./EventList";
import { FileList } from "./FileList";
import styles from "./TabbedSidebar.module.css";
import { TopicsList } from "./TopicsList";

interface TabbedSidebarProps {
  containerClassName?: classNames.Argument;
  containerStyle?: React.CSSProperties;
}

export function TabbedSidebar(props: TabbedSidebarProps) {
  const { containerClassName, containerStyle = {} } = props;
  const theme = useTheme();
  const sidebar = useWorkspaceSidebar();

  return (
    <section
      className={classNames(styles.container, containerClassName)}
      style={{ backgroundColor: theme.palette.code.main, ...containerStyle }}
    >
      <Tabs
        className={styles.tabs}
        value={sidebar.activeTab}
        onValueChange={(tab: SidebarTab) => sidebar.setActiveTab(tab)}
      >
        <header className={styles.header}>
          <TabsList aria-label="Sidebar" className={styles.tabList}>
            <Tab value={SidebarTab.Files}>Files</Tab>
            <Tab value={SidebarTab.Topics}>Topics</Tab>
            <Tab value={SidebarTab.Events}>Events</Tab>
          </TabsList>
          <RobotoTooltip title="Close Sidebar">
            <span>
              <RobotoIconButton
                onClick={() => sidebar.close()}
                eventName="WorkspaceSidebarClosed"
                size="small"
              >
                <CloseIcon fontSize="small" />
              </RobotoIconButton>
            </span>
          </RobotoTooltip>
        </header>
        <div className={styles.tabPanels}>
          <TabsPanel className={styles.tabPanel} value={SidebarTab.Files}>
            <FileList />
          </TabsPanel>
          <TabsPanel className={styles.tabPanel} value={SidebarTab.Topics}>
            <TopicsList />
          </TabsPanel>
          <TabsPanel className={styles.tabPanel} value={SidebarTab.Events}>
            <EventList />
          </TabsPanel>
        </div>
      </Tabs>
    </section>
  );
}
